<template>
  <div id="modal-agregar-planificacion-anual-charter">

    <!-- Boton que abre modal -->
    <Button
      :size="15"
      color="#2da44e"
      colorText="#ffffff"
      title="Agregar planificación anual"
      icon="fas fa-plus"
      :width="30"
      round
      traslate
      class="m-1"
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" title="Agregar planificación anual" @close="limpiarFormulario()">

      <div class="w-100">
        
        <!-- Form -->
        <div class="d-flex w-100">

          <!-- Año -->
          <ui-select
            class="w-50"
            label="Año"
            hasSearch
            searchPlaceholder="Buscar"
            placeholder="-Seleccionar-"
            :options="listaAnios"
            :keys="{ value: 'id', label: 'year' }"
            v-model="anioModel"
            @change="validarFormulario"
            :disabled="!deshabilitarCampos"
          />

          <!-- Pallet -->
          <ui-select
            class="w-50 ml-2"
            label="Pallet"
            hasSearch
            searchPlaceholder="Buscar"
            placeholder="-Seleccionar-"
            :options="listaPallet"
            :keys="{ value: 'id', label: 'name' }"
            v-model="palletModel"
            @change="validarFormulario"
            :disabled="!deshabilitarCampos"
          />
        
        </div>

        <div class="d-flex">

          <!-- Cliente (Este btn solo será visible con los perfiles que tengan permisos de administración)-->
          <ui-select
            v-if="showSelectClientes"
            class="w-100"
            label="Cliente"
            hasSearch
            searchPlaceholder="Buscar"
            placeholder="-Seleccionar-"
            :options="listaClientesUsuarioActual"
            :keys="{ value: 'id', label: 'name' }"
            v-model="clienteModel"
            @change="validarFormulario"
            :disabled="!deshabilitarCampos"
          />
        </div>

        <!-- Botones -->
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-default mr-3" @click="closeModal('modal')">Cerrar</button>
          <button class="btn btn-primary" v-if="botonAddFormularioActivo" @click="enviarPlanificacionAnual()">Aceptar</button>
          <button class="btn btn-primary" v-else disabled>Aceptar</button>
        </div>

      </div>

    </ui-modal>
  </div>
</template>

<script>

  // Vue
  import Vue from "vue";

  // Toast
  import VueToastify from "vue-toastify";
  Vue.use(VueToastify);

  // Moment
  import { mapActions, mapState } from "vuex";

  // Select UI
  import UiModal from "keen-ui/src/UiModal";
  import UiSelect from "keen-ui/src/UiSelect";

  // Componentes
  import Button from "../../../common/Button";
  import { savePlanificacionAnualCharter } from '../../../../constants/charter';

  export default {
    props: ["semanas"],

    data() {
      return {
        anioModel: [],
        palletModel: {},
        clienteModel: {},
        servicioModel: {},
        botonAddFormularioActivo: false,
        data: [],
        desactivarBtnFiltrar: false,
        deshabilitarCampos: true,
        showSelectClientes: false
      };
    },

    computed: {
      ...mapState(["listaClientesUsuarioActual", "usuarioActual","usuarioActual"]),
      ...mapState("charter", ["listaServicios","listaAnios","listaPallet"]),
    },

    components: { UiModal, UiSelect, Button },

    methods: {

      ...mapActions("charter", ["actionSetDataDataTablePlanificacionAnual","actionSetDataPlanificacionAnualTabla"]),

      openModal(ref) {
        this.$refs[ref].open();
      },

      closeModal(ref) {
        this.$refs[ref].close();
      },

      validarFormulario() {

        if ( Object.keys(this.anioModel).length && Object.keys(this.palletModel).length && Object.keys(this.clienteModel).length ) {
          this.botonAddFormularioActivo = true;
        } else {
          this.botonAddFormularioActivo = false;
        }

      },

      async enviarPlanificacionAnual() {

        this.$vToastify.loader("Creando planificación");
        this.botonAddFormularioActivo = false;

        let data = 
          [{
            type : 1,
            data : {
              year      : this.anioModel.id,
              client_id : this.clienteModel.id,
              pallet_id : this.palletModel.id,
              total     : 0
            }
          }];


        let {code, message} = await savePlanificacionAnualCharter(data);

        if (code == 200) {

          // Detener Toast info
          this.$vToastify.stopLoader();

          // Toast proceso exitoso
          this.$vToastify.success(
            message,
            "Proceso finalizado"
          );

          this.closeModal('modal');
          this.limpiarFormulario();

          this.actionSetDataPlanificacionAnualTabla();
         this.botonAddFormularioActivo = true;

        } else {

          // Detener Toast info
          this.$vToastify.stopLoader();

          // Toast proceso exitoso
          this.$vToastify.success(
            message,
            "Proceso finalizado"
          );

         this.botonAddFormularioActivo = true;
          
        }
        
      },

      limpiarFormulario(){
        this.anioModel = [];
        this.palletModel = [];
        this.clienteModel = [];
      }

    },

    mounted(){

      if (this.usuarioActual.rol == 'Administrador' || this.usuarioActual.rol == "Ejecutivo" || this.usuarioActual.rol == "Super Administrador") {
        
        this.showSelectClientes = true;

      }else{

        this.showSelectClientes = false;
        this.clienteModel = [{id:this.usuarioActual.id_cliente, name:this.usuarioActual.cliente}];

      }

    }
  }

</script>

<style>

  #modal-agregar-planificacion-anual-charter .ui-modal__container{
    width: 40% !important;
  }

</style>
